import FinancialContractModule from './Financial'
import BuyContractModule from './Buy'
import SaleContractModule from './Sale'
import FinancialEndowmentContractModule from './Endowment'
import DonationModule from './Donation'
import PeaceModule from './Peace'
import ExchangeModule from './Exchange'
import MortgageModule from './Mortgage'
import MudarabaModule from './Mudaraba'
import RentModule from './Rent'

export default {
  subModules: {
    financial: FinancialContractModule,
    buy: BuyContractModule,
    sale: SaleContractModule,
    financialEndowment: FinancialEndowmentContractModule,
    donation: DonationModule,
    peace: PeaceModule,
    exchange: ExchangeModule,
    mudaraba: MudarabaModule,
    mortgage: MortgageModule,
    rent: RentModule,
  },
}
